@if (!loading && images.length) {
  <gallery [items]="images" thumbPosition="left" [thumbAutosize]="false"
    [counter]="false"
    [debug]="false"
  ></gallery>
}
@if (!loading && !images.length) {
  <pub-no-image size="300px"></pub-no-image>
}
